if (!customElements.get('before-after-slider')) {
  customElements.define(
    'before-after-slider',
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('.before-after__toggle-btn'));
        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.setView(button.dataset.view));
        });
      }

      setView(view) {
        this.setAttribute('data-state', view);
        this.buttons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.view === view ? 'true' : 'false');
        });
      }
    }
  );
}
